module.exports = __webpack_public_path__ + "img/aircraft.38729def.svg";